// libs
import { connect } from 'react-redux';
import get from 'lodash/get';
import { client } from '@biw/contests-core';

import {
    sortAccountHistory,
    showMoreAccountHistory
} from '../profile-dux';

import AccountHistory from './account-history';

const mapStateToProps = state => ( {
    accountHistory: get( state, 'profile.accountHistory', null ),
    mediaLabel: client.selectors.getMediaLabel( state ),
    accountBalance: get( state, 'user.accountBalance', null )
} );

const mapDispatchToProps = {
    sortAccountHistory,
    showMoreAccountHistory
};

export default connect( mapStateToProps, mapDispatchToProps )( AccountHistory );
